'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedNumber = require('./FormattedNumber');

var _FormattedNumber2 = _interopRequireDefault(_FormattedNumber);

var _NumberTypes = require('../constants/NumberTypes');

var _NumberTypes2 = _interopRequireDefault(_NumberTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'FormattedPercentage',

  propTypes: {
    precision: _react.PropTypes.number,
    stripInsignificantZeros: _react.PropTypes.bool,
    value: _react.PropTypes.number.isRequired
  },

  render: function render() {
    return _react2.default.createElement(_FormattedNumber2.default, _extends({ style: _NumberTypes2.default.PERCENTAGE }, this.props));
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.297/js/components/FormattedPercentage.js
// module id = 339
// module chunks = 0